import React, { useCallback, useMemo } from "react";
import "./index.css";
import { RESTAURANT_ID } from "../../../constants/constans";
import { useAuth } from "../../../context/AuthContext";
import { useGetMenuCustomListFromCustomerSiteQuery, useGetMenuSetListFromCustomerSiteQuery, useGetMenuSingleListFromCustomerSiteQuery } from "../../../redux/services/setMenuService";
import { MenuItem } from "../../Home";
import { getImageUrlWithFallback } from "../../../utility/Utility";
import img2 from "../../../assets/images/Defult.PNG";
import defaultImage from "../../../assets/images/Defult.PNG";
import { useSelector } from "react-redux";
import { initialData } from "../../../redux/services/initialDataService";


const RotatingItems = () => {
  const { isAuthenticated } = useAuth();

  const restaurantId = RESTAURANT_ID;

  // const { data: initialData } =
  //   useGetInitialDataQuery(undefined, { skip: !isAuthenticated });
  const initialData: initialData = useSelector(
    (state: any) => state.initialData
  );

  const { data: singleMenuData } =
    useGetMenuSingleListFromCustomerSiteQuery(restaurantId, { skip: !isAuthenticated });

  const { data: setMenuData } =
    useGetMenuSetListFromCustomerSiteQuery(restaurantId, { skip: !isAuthenticated });

  const { data: customMenuData } =
    useGetMenuCustomListFromCustomerSiteQuery(restaurantId, { skip: !isAuthenticated });

  const findProductDetails = useCallback(
    (itemId: string, itemType: string) => {
      switch (itemType) {
        case "MenuItem":
          return singleMenuData?.menusItems?.find(
            (item: MenuItem) => item.id === itemId || item.itemId === itemId
          );
        case "setMenu":
          return setMenuData?.setMenus?.find(
            (item: MenuItem) => item.id === itemId || item.itemId === itemId
          );
        case "customMenu":
          return customMenuData?.customMenus?.find(
            (item: MenuItem) => item.id === itemId || item.itemId === itemId
          );
        default:
          return null;
      }
    },
    [singleMenuData, setMenuData, customMenuData]
  );
  const sliderProductsWithDetails = useMemo(() => {
    return (
      initialData?.home?.sliderProducts
        ?.map((product) => {
          const details = findProductDetails(product.itemId, product.itemType);
          return {
            ...product,
            ...details,
            // Ensure we have the required properties
            image: details?.imageUrl || img2,
            display: details?.displayName || "Unknown Product",
          };
        })
        .filter((product) => product.image && product.display) || []
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData, singleMenuData, setMenuData, customMenuData]);


  return (
    <div className="rotating-container">
      <div className="rotating-track">
        {sliderProductsWithDetails.map((product, index) => (
          <div className="rotating-item" key={`product-${index}`}>
            <img
              src={getImageUrlWithFallback(product.image, defaultImage, 64)}
              alt={product.display}
              className="rotating-image"
            />
            <p className="rotating-label">{product.display}</p>
          </div>
        ))}
        {sliderProductsWithDetails.map((product, index) => (
          <div
            className="rotating-item"
            key={`product-repeat-1-${index}`}
          >
            <img
              src={getImageUrlWithFallback(product.image, defaultImage, 64)}
              alt={product.display}
              className="rotating-image"
            />
            <p className="rotating-label">{product.display}</p>
          </div>
        ))}
        {sliderProductsWithDetails.map((product, index) => (
          <div
            className="rotating-item"
            key={`product-repeat-2-${index}`}
          >
            <img
              src={getImageUrlWithFallback(product.image, defaultImage, 64)}
              alt={product.display}
              className="rotating-image"
            />
            <p className="rotating-label">{product.display}</p>
          </div>
        ))}
        {sliderProductsWithDetails.map((product, index) => (
          <div
            className="rotating-item"
            key={`product-repeat-3-${index}`}
          >
            <img
              src={getImageUrlWithFallback(product.image, defaultImage, 64)}
              alt={product.display}
              className="rotating-image"
            />
            <p className="rotating-label">{product.display}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RotatingItems;
